import { Typography } from 'antd'
import { FC } from 'react'
import { Radio } from 'src/sdk/components/form/Radio'
import { CenteredContent, HorizontalSpace, VerticalSpace } from 'src/sdk/components/layout'
import { ListItem, ListItemMeta } from 'src/sdk/components/list/ListItem'
import { PaymentBrand } from 'src/sdk/components/payment-brand/PaymentBrand'
import { withPrefix } from 'src/sdk/contexts/Config'
import { useDynamicDrawer } from 'src/sdk/contexts/DynamicDrawer'
import { PaymentMethodBrand } from 'src/sdk/datasource/config'
import { BankAccount } from 'src/sdk/datasource/wallet/bankaccount'
import { BillingUseTag } from '../BillingUse'
import { PaymentMethodListProps } from '../payment-methods/PaymentMethodList'
import BankAccountView from './BankAccountView'

type PaymentCardProps = PaymentMethodListProps & {
  checked?: boolean
  editable?: boolean
  data: BankAccount
}

const BankAccountListItem: FC<PaymentCardProps> = ({ checked, onChecked, editable, data }) => {
  const { setDrawer, setDrawerVisible } = useDynamicDrawer()
  const { id, nickname, brand, lastFour, bankName, verified, verificationStatus } = data

  const handleClick = () => {
    setDrawer({
      content: (
        <CenteredContent>
          <BankAccountView data={data} onDelete={() => setDrawerVisible(false)} />
        </CenteredContent>
      ),
    })
  }

  return (
    <ListItem
      key={id}
      className={withPrefix(
        onChecked ? 'wallet-card-checkable' : '',
        onChecked && checked ? 'wallet-card-checked' : '',
      )}
      onClick={() => {
        onChecked && onChecked(data)
        editable && handleClick()
      }}
    >
      <ListItemMeta
        key={id}
        avatar={{
          size: 48,
          shape: 'square',
          background: 'light',
          icon: (
            <PaymentBrand
              color={'default'}
              type={'full'}
              brand={bankName?.toLowerCase() as PaymentMethodBrand}
              fallbackType={'bank'}
            />
          ),
        }}
        extra={!onChecked && <BillingUseTag billingUse={data.billingUse} />}
        description={
          <HorizontalSpace style={{ justifyContent: 'space-between' }} align={'center'}>
            <VerticalSpace size={0}>
              <Typography.Title type={'secondary'} level={5} style={{ marginBottom: 0 }}>
                {nickname ? nickname : brand}
              </Typography.Title>
              <Typography.Text type={'secondary'} style={{ textTransform: 'capitalize', fontSize: 12 }}>
                {brand}
                {` - ${lastFour}`}
              </Typography.Text>
            </VerticalSpace>
            {onChecked && <Radio defaultChecked={checked} checked={checked} />}
          </HorizontalSpace>
        }
      />
    </ListItem>
  )
}

export default BankAccountListItem
